import { List, ListItem } from "@/components/ui/displays/list";
import { getItineraryTimeLabel } from "@/lib/formatters/availability-formatters";
import { estimatedTimeSpanInSecondsRangeFormatter } from "@/lib/formatters/time-span-formatters";
import { AppItineraryOrNode } from "@/types/otp/+extended";

export function ItineraryCardDetails({ startTime, endTime, duration, legs }:
    Pick<AppItineraryOrNode, "startTime" | "endTime" | "duration" | "legs">
) {
    const timeLabel = getItineraryTimeLabel({ startTime, endTime, legs });

    return (
        <List variant={"simple"} className="text-foreground">
            <ListItem className="py-0 flex flex-row gap-2 flex-wrap justify-between">
                <span
                    className="flex flex-col gap-1 justify-start items-center"
                >
                    {timeLabel && (
                        <>
                            <p className="text-muted-foreground">{timeLabel.label}</p>

                            <p className="text-sm">{timeLabel.value}</p>
                        </>
                    )}
                </span>
                <span
                    className="flex flex-col gap-1 justify-start items-center"
                >
                    <p className="text-muted-foreground">Estimated Trip Duration</p>

                    <p className="text-sm">{estimatedTimeSpanInSecondsRangeFormatter(duration)}</p>
                </span>
            </ListItem>
        </List>
    )
}